import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type FlowAllocationType = DatabaseCode;

const source: FlowAllocationType = {
  code: 'SOURCE',
  displayValue: {
    id: 'ots.ui.entity.flowallocationtype.source',
    defaultMessage: 'Source',
  },
};

const sourceSite: FlowAllocationType = {
  code: 'SOURCE_SITE',
  displayValue: {
    id: 'ots.ui.entity.flowallocationtype.sourcesite',
    defaultMessage: 'Source Site',
  },
};

const destination: FlowAllocationType = {
  code: 'DESTINATION',
  displayValue: {
    id: 'ots.ui.entity.flowallocationtype.destination',
    defaultMessage: 'Destination',
  },
};

const destinationSourceSite: FlowAllocationType = {
  code: 'DEST_SOURCE_SITE',
  displayValue: {
    id: 'ots.ui.entity.flowallocationtype.destinationsourcesite',
    defaultMessage: 'Destination - Source Site',
  },
};

export const flowAllocationType = {
  source,
  sourceSite,
  destination,
  destinationSourceSite,
};

export const flowAllocationTypes = Object.values(flowAllocationType);

export const toFlowAllocationType = (code: string): FlowAllocationType => toDatabaseCode(code, flowAllocationTypes)

export const toFlowAllocationTypeSafely = (code: string | undefined, defaultValue: FlowAllocationType | undefined = undefined): FlowAllocationType | undefined => toDatabaseCodeSafely(code, flowAllocationTypes, defaultValue)
